import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

function GoogleCallback() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    
    if (code) {
      console.log('✅ Código de autorização recebido:', code);
      
      // Enviar código para o backend
      axios.post('https://growly-test-production.up.railway.app/api/google/callback', { code })
        .then(response => {
          console.log('✅ Autenticação concluída:', response.data);
          
          // Notificar a janela pai (popup)
          if (window.opener) {
            window.opener.postMessage({
              type: 'GOOGLE_AUTH_SUCCESS',
              data: response.data
            }, '*');
            window.close();
          } else {
            navigate('/dashboard');
          }
        })
        .catch(error => {
          console.error('❌ Erro no callback:', error);
          
          if (window.opener) {
            window.opener.postMessage({
              type: 'GOOGLE_AUTH_ERROR',
              error: error.message
            }, '*');
            window.close();
          }
        });
    }
  }, [location, navigate]);

  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <h2>Processando autenticação Google Ads...</h2>
      <p>Aguarde, você será redirecionado.</p>
    </div>
  );
}

export default GoogleCallback;